import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { DashboardStatistic } from "../../generalSettings/dashboard";
import { DashboardEntity } from "./dashboardConfig";


export interface IDashboardDataService {
    getData: (entity: DashboardEntity) => DashboardStatistic[];
    setAvailableStatistics: (availableStatistics: DashboardStatistic[]) => void;
}
export class DashboardDataServiceFactory {

    private static cache: DashboardStatistic[];

    private static getCachedData = async () => {
        if (!Helper.hasValue(DashboardDataServiceFactory.cache)) {
            const result = await HTTPService.get<JsonResultClass<DashboardStatistic[]>>("Dashboard/GetAvailableStatistics");
            if (result.Code == 0) {
                DashboardDataServiceFactory.cache = result.Data;
            }
        }
        return DashboardDataServiceFactory.cache;
    }


    static getStandard = async () => {
        const data = await DashboardDataServiceFactory.getCachedData();
        const service = new DataService();
        service.setAvailableStatistics(data);
        return service;
    }

    static getCustom = async () => {
        const data = await DashboardDataServiceFactory.getCachedData();
        const service = new CustomDataService();
        service.setAvailableStatistics(data);
        return service;
    }
}
class DataService implements IDashboardDataService {

    private availableStatistics: DashboardStatistic[];
    getData = (entity: DashboardEntity) => {
        let data: DashboardStatistic[] = JSON.parse(JSON.stringify(entity.DashboardStatistics));
        if (!Helper.hasValue(data) || data.length == 0) {
            data = this.availableStatistics;
        }
        this.availableStatistics
            .filter(item => data.findIndex(s => s.StatisticId == item.StatisticId) == -1)
            .forEach((item) => {
                item.Permission = 2;
                data.push(item);
            });
        for (let pos = 0; pos < data.length; pos++) {
            data[pos].Pos = pos;
        }


        return data;
    }

    setAvailableStatistics = (availableStatistics: DashboardStatistic[]) => {
        this.availableStatistics = availableStatistics;
    }
}
class CustomDataService implements IDashboardDataService {
    private availableStatistics: DashboardStatistic[];

    getData = (entity: DashboardEntity) => {
        const dashboardStatistics: DashboardStatistic[] = JSON.parse(JSON.stringify(entity.DashboardStatistics));
        let data: DashboardStatistic[] = JSON.parse(JSON.stringify(entity.CustomDashboardStatistics));
        if (!Helper.hasValue(data) || data.length == 0) {
            data = dashboardStatistics;
            data = data.filter(ds => ds.Permission > 0);
        }
        if (!Helper.hasValue(data) || data.length == 0) {
            data = this.availableStatistics;
        }
        if (Helper.hasValue(dashboardStatistics) && dashboardStatistics.length > 0) {
            dashboardStatistics
                .filter(item => data.findIndex(s => s.StatisticId == item.StatisticId) == -1 && item.Permission > 0)
                .forEach((item) => {
                    item.Permission = 0;
                    data.push(item);
                });
        } else if (Helper.hasValue(this.availableStatistics) && this.availableStatistics.length > 0) {
            this.availableStatistics
                .filter(item => data.findIndex(s => s.StatisticId == item.StatisticId) == -1)
                .forEach((item) => {
                    item.Permission = 1
                    data.push(item);
                });
        }



        for (let i = 0; i < data.length; i++) {
            data[i].Pos = i;
        }
        return data;
    }

    setAvailableStatistics = (availableStatistics: DashboardStatistic[]) => {
        this.availableStatistics = availableStatistics;
    }
}